import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en";
import cs from "./cs";
import { LocaleType } from "./LocaleType";
import { de } from "./de";
import { cy } from "./cy";

const AVAILABLE_LOCALES = ["cs", "en", "de", "cy"];
type AvailableLocales = typeof AVAILABLE_LOCALES[number];

type LocaleDefinition = {
    /** Mezinárodní název jazyka */
    name: string,
    /** Kód jazyka používaný v i18next */
    code: AvailableLocales,
    /** Překladové objekty */
    translation: LocaleType
}



export const LOCALES: Record<AvailableLocales, LocaleDefinition> = {
    cs: {
        name: "Česky",
        code: "cs",
        translation: cs
    },
    en: {
        name: "English",
        code: "en",
        translation: en
    },
    de: {
        name: "Deutsch",
        code: "de",
        translation: de
    },
    cy: {
        name: "Cymraeg",
        code: "cy",
        translation: cy
    }
}


i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: LOCALES,
        supportedLngs: AVAILABLE_LOCALES,
        fallbackLng: "en",
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "lang"
        },
        interpolation: {
            escapeValue: false // React už escapuji
        },
        react: {
            useSuspense: false
        }
    });


export default i18n;